import { useTranslation } from "react-i18next"
import { format } from "react-string-format"

const TextAreaInput = (props: any) => {
    const [t] = useTranslation()

    return (
        <div className={`group form-floating w-full relative ${(props.errors) ? ` validation-error` : ``}`}>
            <textarea
                {...props.register(props.name as string, props.rules as any)}
                {...props}
                className="form-text transition-all"
                autoComplete="off" />
            <label htmlFor="outline" className="peer-focus:text-xs peer-focus:-top-[8px] peer-focus:text-gray-800 dark:peer-focus:text-white peer-placeholder-shown:text-lg peer-placeholder-shown:top-3">
                <span className="relative">
                    {props.label}
                    {props.rules?.required && <span style={{ color: "#d84b4b" }}>*</span>}
                </span>
            </label>

            {props.errors && props.errors.type as any === 'required' &&
                <div className="text-error text-xs mt-1 hidden group-[.validation-error]:block">{props.errors.message ? props.errors.message : format(t('VALIDATION_ERROR_REQUIRED'), props.label)}</div>}

            {props.errors && props.errors.type as any == 'minLength' &&
                <div className="text-error text-xs mt-1 hidden group-[.validation-error]:block">
                    {props.errors.message ? props.errors.message :
                        (props.rules?.maxLength == undefined || props.rules?.minLength == props.rules?.maxLength ?
                            format(t('VALIDATION_ERROR_EXACT_STRING_LENGTH'), props.label, props.rules?.minLength)
                            :
                            format(t('VALIDATION_ERROR_STRING_LENGTH'), props.label, props.rules?.minLength, props.rules?.maxLength))}
                </div>}

            {props.errors && props.errors.type as any == 'maxLength' &&
                <div className="text-error text-xs mt-1 hidden group-[.validation-error]:block">
                    {props.errors.message ? props.errors.message :
                        (props.rules?.minLength == undefined || props.rules?.minLength == props.rules?.maxLength ?
                            format(t('VALIDATION_ERROR_EXACT_STRING_LENGTH'), props.label, props.rules?.maxLength)
                            :
                            format(t('VALIDATION_ERROR_STRING_LENGTH'), props.label, props.rules?.minLength, props.rules?.maxLength))}
                </div>}

            {props.errors && props.errors.type as any == 'validate' &&
                <div className="text-error text-xs mt-1 hidden group-[.validation-error]:block">
                    {props.errors.message ? props.errors.message :
                        format(t('VALIDATION_ERROR_INVALID'), props.label)}
                </div>}
        </div>
    )
}

export default TextAreaInput